export default "__VITE_ASSET__d292a2c6__"